import React from 'react';
import Tooltip from '../../../../../layout/ReusableComponent/Tooltip/Tooltip';

export function ShellSideNavItem({
  label,
  tooltipText,
  isNavCollapsed,
  className = '',
  icon,
  iconTone,
  trailing = null,
  ...buttonProps
}) {
  const renderedIcon =
    iconTone && icon ? (
      <span
        className={`support-open-disc-shell-side-item-icon support-open-disc-shell-side-item-icon--${iconTone}`}
        aria-hidden
      >
        {icon}
      </span>
    ) : (
      icon
    );

  const button = (
    <button type="button" className={`support-open-disc-shell-side-item${className}`} {...buttonProps}>
      {renderedIcon}
      <span className="support-open-disc-shell-side-item-label">{label}</span>
      {trailing}
    </button>
  );

  if (!isNavCollapsed) return button;

  return (
    <Tooltip text={tooltipText || label} position="right" className="tooltip-container--block">
      {button}
    </Tooltip>
  );
}
